import { getToken, setToken, removeToken, TokenKey } from '@/utils/auth'
import {
  login,
  logout,
  statusUpdate,
  UserInfo,
  apiWorkOrderDictList,
  queryShiftDetail,
  autoUpdateShiftStatus
} from '@/api/login'
import { apiImOpenReadConfig } from '@/api/chat'
export default {
  namespaced: true,
  state: {
    workStatus: 0, // 0-坐班中接收 1-休息中 2-坐班中拒收
    token: getToken(),
    userId: '',
    chatId: '',
    userInfo: {},
    workorderDict: [],
    isAdmin: false,
    isOpenReadAck: true, // 当前角色是否展示已读未读功能
    shiftStatusConfig: {}, // 坐班状态配置
    autoRestStatus: true, // 坐班状态自动休息开关
    config: {
      // 系统配置项
      recallTime: 24 * 60 * 60 * 1000
    },
    imConfig: {}
  },
  mutations: {
    SET_WORK_STATUS(state, STATUS) {
      state.workStatus = STATUS || 0
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_ID(state, userId) {
      state.userId = userId
    },
    SET_CHAT_ID(state, chatId) {
      state.chatId = chatId
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_WORK_DICT(state, res) {
      state.workorderDict = res
    },
    SET_ISADMIN_STATUS(state, isAdmin) {
      state.isAdmin = isAdmin
    },
    SET_OPEN_READ_ACK(state, isOpen) {
      state.isOpenReadAck = isOpen
    },
    SET_SHIFT_STATUS_CONFIG(state, config) {
      state.shiftStatusConfig = config
    },
    SET_IM_CONFIG(state, config = {}) {
      state.imConfig = config
    }
  },
  actions: {
    logIn({ commit }, userForm) {
      return new Promise((resolve, reject) => {
        login(userForm)
          .then(res => {
            commit('SET_TOKEN', res.token)
            setToken(res.token)
            resolve(res)
          })
          .catch(err => reject(err))
      })
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        UserInfo()
          .then(res => {
            const { ucUserId, emUserId, shiftStatus } = res
            commit('SET_USER_ID', ucUserId)
            commit('SET_CHAT_ID', emUserId)
            commit('SET_WORK_STATUS', shiftStatus)
            commit('SET_USER_INFO', res)
            resolve(res)
          })
          .catch(() => reject())
      })
    },
    logOut({ commit }, query) {
      return new Promise((resolve, reject) => {
        logout(query)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_USER_ID', '')
            commit('SET_CHAT_ID', '')
            removeToken()
            resolve()
          })
          .catch(() => reject())
      })
    },
    handleChangeWorkStatus({ commit }, { status, reason }) {
      return new Promise((resolve, reject) => {
        statusUpdate({
          shiftStatus: status,
          switchReason: reason || undefined
        })
          .then(() => {
            commit('SET_WORK_STATUS', status)
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    setWorkorderMap({ commit }) {
      return new Promise((resolve, reject) => {
        apiWorkOrderDictList()
          .then(res => {
            let workOrderType = []
            try {
              workOrderType = res
            } catch {
              workOrderType = []
            }
            commit('SET_WORK_DICT', workOrderType)
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    setOpenImReadAck({ commit }) {
      apiImOpenReadConfig().then(res => {
        const { readUnreadSwitch } = res
        commit('SET_OPEN_READ_ACK', readUnreadSwitch)
      })
    },
    queryShiftStaus({ commit }) {
      return new Promise((resolve, reject) => {
        queryShiftDetail()
          .then(res => {
            const {
              currentContinueUntreatedTimes = 0,
              doctorAssistantContinueUntreatedTimes = 0,
              autoRestTriggerTime,
              currentAutoRestTime
            } = res
            commit('SET_SHIFT_STATUS_CONFIG', {
              currentContinueUntreatedTimes, // 已拒收数
              doctorAssistantContinueUntreatedTimes, //最大拒收数
              autoRestTriggerTime, // 拒收到自动休息时间配置
              currentAutoRestTime // 自动休息准确时间
            })
            resolve()
          })
          .catch(() => reject())
      })
    },
    shiftStatusAutoChange({ commit }, { status, reason }) {
      return new Promise((resolve, reject) => {
        autoUpdateShiftStatus({ shiftStatus: status, switchReason: reason || undefined })
          .then(() => {
            commit('SET_WORK_STATUS', status)
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    }
  }
}
